import { createElement } from 'react';
import { SvgIcon } from '@elementary/common-ui/components';
import { WarehouseType } from '@elementary/common-ui/types';
import { getWarehouseIcon } from '@elementary/common-ui/utils/environments';

type Props = {
  warehouseType: WarehouseType;
};

const WarehouseTypeIcon = ({ warehouseType }: Props) => (
  <SvgIcon width={16} height={16}>
    {createElement(getWarehouseIcon(warehouseType))}
  </SvgIcon>
);

export default WarehouseTypeIcon;
